module.exports = "<div class=\"container\" fxLayout=\"column\">\r\n  <div class=\"main-content\">\r\n    <p class=\"mat-display-4\">500</p>\r\n\r\n    <h1 class=\"mat-display-1\">An error has occurred please try again or contact the support and provide this error Id:  {{ error$ | async }} </h1>\r\n\r\n    <button mat-raised-button (click)=\"onBack()\" color=\"accent\">BACK</button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-page/error-page.component.html
// module id = ./src/app/shared/error-page/error-page.component.html
// module chunks = main